<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="as-Menu as-TopCenter">
			<h4>Add or Modify:</h4>

			<div class="as-MenuGrid">
				<input class="RAD" style="margin: 0px" value="New" id="New" type="radio" name="AddModify" [(ngModel)]="attendanceData.AddModifyOption" />
				<label style="margin: 0px" for="New">Add new Attendance </label>

				<input class="RAD" style="margin: 0px" value="Modify" id="Modify" type="radio" name="AddModify" [(ngModel)]="attendanceData.AddModifyOption" />
				<label style="margin: 0px" for="Modify">Modify Existing Attendance </label>

				<!-- <input class="RAD" style="margin: 0px" value="CSV" id="CSV" type="radio" name="AddModify" [(ngModel)]="attendanceData.AddModifyOption" />
				<label style="margin: 0px" for="CSV">Upload CSV </label> -->
			</div>
		</div>

		<div *ngIf="attendanceData.AddModifyOption == 'CSV'">
			<caass-batch-attendance-csv></caass-batch-attendance-csv>
		</div>

		<div *ngIf="attendanceData.AddModifyOption != 'CSV'">
			<div class="as-Menu as-TopCenter">
				<label class="control-label">School</label>
				<div class="as-SchoolMenu">
					<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="attendanceData.SchoolID">
                    <option value="" style="display:none;"></option>
                    <span class="border border-dark"></span>
                    <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">[{{o.SchoolNumber}}] - {{o.SchoolName}}</option>
                </select> -->

					<caass-schoolselector [ShowAll]="false"> </caass-schoolselector>
				</div>
			</div>

			<div class="as-Menu as-TopCenter">
				<h4>Select Students:</h4>

				<div class="as-MenuGrid">
					<!--Calendar Day Type-->
					<label>By: </label>
					<!--Dropdown-->
					<select class="form-control" name="By" [(ngModel)]="attendanceData.StudentType" (ngModelChange)="onStudentTypeChange($event)">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstStudentsBy" [ngValue]="o.StudentType">
							{{ o.StudentType }}
						</option>
					</select>
					<label>Selection: </label>
					<!--Dropdown-->
					<select class="form-control" name="By" [(ngModel)]="attendanceData.SelectionVal">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstSelectionVals" [ngValue]="o.ID">
							{{ o.Desc }}
						</option>
					</select>
				</div>
			</div>
			<div class="as-Menu as-TopCenter">
				<h4>Attendance Type:</h4>

				<div class="as-MenuGrid">
					<input
						class="RAD"
						style="margin: 0px"
						value="OnTime"
						id="OnTime"
						name="AttendanceType"
						type="radio"
						[(ngModel)]="attendanceData.AttendanceType"
					/>
					<label style="margin: 0px" for="OnTime">Mark Students On Time </label>

					<input
						class="RAD"
						style="margin: 0px"
						value="Tardy"
						id="Tardy"
						name="AttendanceType"
						type="radio"
						[(ngModel)]="attendanceData.AttendanceType"
					/>
					<label style="margin: 0px" for="Tardy">Mark Students Tardy </label>

					<input
						class="RAD"
						style="margin: 0px"
						value="Absent"
						id="Absent"
						name="AttendanceType"
						type="radio"
						[(ngModel)]="attendanceData.AttendanceType"
					/>
					<label style="margin: 0px" for="Absent">Mark Students Absent </label>
				</div>
			</div>

			<div class="as-Menu as-TopCenter">
				<h4>Attendance Information:</h4>
				<div class="as-MenuGrid">
					<label>Entry Date</label>
					<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="attendanceData.StartDate" name="txtStartDate"></p-calendar>

					<label *ngIf="ShowEntryTimeOption() == true">Update Entry Time?</label>
					<input *ngIf="ShowEntryTimeOption() == true" type="checkbox" class="CHK" [(ngModel)]="ChangeEntryTime" />

					<label *ngIf="ShowEntryTime() == true">Entry Time</label>
					<p-calendar
						*ngIf="ShowEntryTime() == true"
						showIcon="true"
						showButtonBar="true"
						timeOnly="true"
						showTime="true"
						hourFormat="12"
						[(ngModel)]="attendanceData.StartTime"
						name="txtStartDate"
					></p-calendar>

					<label *ngIf="attendanceData.AttendanceType != 'OnTime'">Excuse:</label>
					<select *ngIf="attendanceData.AttendanceType != 'OnTime'" class="form-control" name="By" [(ngModel)]="attendanceData.ExcuseID">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of lstAttendanceExcuses" [ngValue]="o.ExcuseID">
							{{ o.ExcuseDesc }}
						</option>
					</select>
				</div>
			</div>

			<div class="as-Buttons">
				<button class="btn btn-primary" (click)="onUpdate()">Update</button>
			</div>

			<!--Error Message-->
			<div class="form-group TopMargin">
				<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
					{{ errorMessage }}
				</div>
			</div>
		</div>
	</div>
</div>
